var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Message } from '../message';
import { MessageType } from '../messageType';
import { PhilModalTheme } from '../PhilModalTheme';
import { PhilModalVariant } from '../PhilModalVariant';
export var InitialModalSize;
(function (InitialModalSize) {
    InitialModalSize[InitialModalSize["Small"] = 0] = "Small";
    InitialModalSize[InitialModalSize["Normal"] = 1] = "Normal";
    InitialModalSize[InitialModalSize["DatePicker"] = 2] = "DatePicker";
})(InitialModalSize || (InitialModalSize = {}));
var ShowModalMessage = /** @class */ (function (_super) {
    __extends(ShowModalMessage, _super);
    function ShowModalMessage(variant, url, key, theme, shorterSwipeableOverlay, initialModalSize, prescriptionHistoryStyle) {
        if (variant === void 0) { variant = PhilModalVariant.Center; }
        if (key === void 0) { key = new Date().toString(); }
        if (theme === void 0) { theme = PhilModalTheme.Default; }
        if (shorterSwipeableOverlay === void 0) { shorterSwipeableOverlay = false; }
        if (initialModalSize === void 0) { initialModalSize = InitialModalSize.Normal; }
        if (prescriptionHistoryStyle === void 0) { prescriptionHistoryStyle = false; }
        var _this = _super.call(this, MessageType.SHOW_MODAL) || this;
        _this.variant = variant;
        _this.url = url;
        _this.key = key;
        _this.theme = theme;
        _this.shorterSwipeableOverlay = shorterSwipeableOverlay;
        _this.initialModalSize = initialModalSize;
        _this.prescriptionHistoryStyle = prescriptionHistoryStyle;
        return _this;
    }
    ShowModalMessage.WithShorterSwipeableOverlay = function (variant, url) {
        return new ShowModalMessage(variant, url, new Date().toString(), PhilModalTheme.Default, true);
    };
    ShowModalMessage.WithSelectedModalTheme = function (variant, url, theme) {
        return new ShowModalMessage(variant, url, new Date().toString(), theme, false);
    };
    ShowModalMessage.WithSmallInitialSize = function (variant, url) {
        return new ShowModalMessage(variant, url, new Date().toString(), PhilModalTheme.Default, false, InitialModalSize.Small);
    };
    ShowModalMessage.WithDatePickerSize = function (variant, url) {
        return new ShowModalMessage(variant, url, new Date().toString(), PhilModalTheme.Default, false, InitialModalSize.DatePicker);
    };
    ShowModalMessage.WithPrescriptionHistoryStyles = function (variant, url) {
        return new ShowModalMessage(variant, url, new Date().toString(), PhilModalTheme.Default, false, InitialModalSize.Normal, true);
    };
    ShowModalMessage.WithErrorView = function (variant) {
        return new ShowModalMessage(variant, '');
    };
    return ShowModalMessage;
}(Message));
export { ShowModalMessage };
